
import Vue from 'vue'

const state = {
	collegeTreeData: [],
	lastSelectClient: null,
	nowSelectClient: null,
	isUpdateTree: '0',
	selectedNodeList: null,
}

const getters = {

}

const mutations = {
	change_name(state, anotherName) {
		console.log('college mutations change_name = ', anotherName)
		state.useName = anotherName
	},

	chooseSession(state, obj) {
		console.log('college mutations chooseSession selectedClient = ', state.nowSelectClient)
		console.log('college mutations chooseSession lastClient = ', state.lastSelectClient)

		if (state.lastSelectClient !== null) {
			var s1 = state.lastSelectClient
			s1.os = '0'
			// s1.cmcount = 3
			state.lastSelectClient = s1
			console.log('college mutations chooseSession lastClient11 = ', state.lastSelectClient)
		}

		var s = obj
		s.os = '1'
		// s.cmcount = 4
		state.nowSelectClient = s
		console.log('college mutations chooseSession selectedClient11 = ', state.nowSelectClient)
	},

	//ws --- 23
	updateState(state, data) {
		console.log('college updateState data = ', data)
		// const depids = data.data.depIds
		// var ilength = depids.length
		// var j = -1
		const csid = data.data.csid
		function upState(result) {
			result.map(item => {
				if (item.nodes) {
					var customerList = item.nodes
					for (var m = 0; m < customerList.length; m++) {
						var customer = customerList[m]
						if (customer.nodes) {
							upState(item.nodes)
						}
						const status = data.data.status
						let sort;
						// 40 30 20 10  在线，忙碌，离线，登出
						if (status === 1) {
							sort = 40
						} else if (status === 2) {
							sort = 30
						}
						else if (status === 0) {
							sort = 20
						}
						else if (status === -1) {
							sort = 10
						}
						if (customer.id === csid) {
							customer.userStatus = status
							customer.sort = sort
							if (customer.userStatus === 1 || customer.userStatus === 2) {
								customer.csTimeLength = '刚刚'
							}
							console.log('college upState customer = ', customer)
						}
					}
				}
			})
		}
		upState(state.collegeTreeData)
		function arraySort(temp) {
			for (let index = 0; index < temp.length; index++) {
				if (temp[index].nodes) {
					arraySort(temp[index].nodes);
				}
			}
			temp.sort((a, b) => {
				return b.sort - a.sort;
			});
		}
		arraySort(state.collegeTreeData);
		console.log("state.collegeTreeData:", state.collegeTreeData);
	},

	updateStateTime(state, data) {
		console.log('college updateStateTime data = ', data)

		const collegeList = data.data.colleagueList
		if (!collegeList) {
			return
		}
		collegeList.forEach(function (obj, index) {
			console.log('college eachUpdateTime obj = ', obj)
			console.log('college eachUpdateTime index = ', index)

			const depids = obj.depIds

			var ilength = depids.length
			var j = -1

			function upTime(result) {

				j = j + 1

				result.map(item => {
					if (item.nodes) {
						// 递归调用
						const depid = depids[j]
						console.log('item = ', item)

						if (item.id === depid) {
							if (ilength - j === 1) {
								var customerList = item.nodes
								for (var m = 0; m < customerList.length; m++) {
									var customer = customerList[m]
									const csid = obj.csid
									if (customer.id === csid) {
										console.log('custom00 = ', customer)
										Vue.set(customer, 'csTimeLength', obj.csTimeLength)
										console.log('custom0011 = ', customer)
									}
								}
							} else {

								upTime(item.nodes)
							}
						}

					}
				})
			}

			upTime(state.collegeTreeData)
		})
	},

	// eachUpdateTime(obj, index) {
	// 	console.log('college eachUpdateTime obj = ', obj)
	// 	console.log('college eachUpdateTime index = ', index)

	// 	const depids = obj.depIds

	// 	var ilength = depids.length
	// 	var j = -1

	// 	function upTime(result) {

	// 		j = j + 1

	// 		result.map(item => {
	// 			if (item.nodes) {
	// 				// 递归调用
	// 				const depid = depids[j]

	// 				if (item.id === depid) {
	// 					console.log('college upTime item11 = ', item)

	// 					if (ilength - j === 1) {
	// 						console.log('college upTime item99 = ', item)

	// 						var customerList = item.nodes
	// 						for(var m = 0; m < customerList.length; m++) {
	// 							var customer = customerList[m]

	// 							const csid = obj.csid
	// 							if (customer.id === csid) {

	// 								console.log('upTime customer = ', customer)
	// 							}
	// 						}
	// 					} else {

	// 						upTime(item.nodes)
	// 					}
	// 				}

	// 			}	
	// 		})
	// 	}

	// 	upTime(obj)
	// },

	updateStatus(state, data) {
		console.log('college updateStatus data = ', data)

		const depids = data.data.depIds

		var ilength = depids.length
		var j = -1

		function upStatus(result) {
			j = j + 1
			result.map(item => {
				if (item.nodes) {
					// 递归调用
					const depid = depids[j]
					if (item.id === depid) {
						console.log('college upStatus item11 = ', item)
						if (ilength - j === 1) {
							console.log('college upStatus item99 = ', item)
							var customerList = item.nodes
							for (var m = 0; m < customerList.length; m++) {
								var customer = customerList[m]

								const csid = data.data.csid
								if (customer.id === csid) {

									var sessionList = customer.nodes
									const cid = data.data.sess.cid
									// const sid = data.data.sess.sid
									if (sessionList && sessionList.length > 0) {
										for (var n = 0; n < sessionList.length; n++) {
											var session = sessionList[n]
											console.log('upStatus customer = ', customer)

											if (session.cid === cid) {
												console.log('upStatus session = ', session)

												const status = data.data.customerStatus
												session.customerStatus = status
											}
										}
									}
								}
							}
						} else {
							upStatus(item.nodes)
						}
					}

				}
			})
		}

		upStatus(state.collegeTreeData)
	},

	updateMsgCount(state, data) {
		console.log('college updateMsgCount data = ', data)
		if (state.nowSelectClient === null) {
			return
		}
		var s = state.nowSelectClient
		s.isChecked = true
		//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
		const iFrom = data.data.msg.from
		if (iFrom === 0) {
			s.cmcount = s.cmcount + 1
		} else if (iFrom === 1 || iFrom === 3) {
			s.csmcount = s.csmcount + 1
		}
		state.nowSelectClient = s
	},

	addSession(state, data) {
		console.log('college addSession data = ', data)
		console.log('college addSession item.cid ', data.data.customerSess.cid)
		const csid = data.data.csid
		const customerSess = data.data.customerSess
		var colleague = this.state.currentColleageInfo
		if (colleague && colleague.id === csid) {
			var cstalkingList = this.state.cstalkingList
			var isexist = false
			for (let i = 0; i < cstalkingList.length; i++) {
				const talk = cstalkingList[i]
				if (talk.cid === customerSess.cid) {
					isexist = true
					this.state.cstalkingList.splice(i, 1, customerSess)
					if (state.nowSelectClient != null) {
						if (state.nowSelectClient.cid == customerSess.cid) {
							let isChecked = state.nowSelectClient.isChecked
							let isFlicker = state.nowSelectClient.isFlicker
							let isNew = state.nowSelectClient.isNew
							state.nowSelectClient = customerSess
							state.nowSelectClient.isChecked = isChecked
							state.nowSelectClient.isFlicker = isFlicker
							state.nowSelectClient.isNew = isNew
						}
					}
					break;
				}
			}
			if (!isexist) {
				console.log('college addSession cstalkingList = ', cstalkingList)
				customerSess.isHave = false
				customerSess.isChecked = false
				customerSess.csid = csid
				customerSess.type = 3
				this.state.cstalkingList.unshift(customerSess)
				console.log('college addSession cstalkingList = ', this.state.cstalkingList)
				const csbrowserList = this.state.csbrowserList
				//会话中的消息 ，删除浏览中的对应的消息列表
				if (csbrowserList.length > 0) {
					for (let i = 0; i < csbrowserList.length; i++) {
						if (csbrowserList[i].cid === customerSess.cid) {
							this.state.csbrowserList.splice(i, 1)
							break
						}
					}
				}
			}
			// console.log('college addSession cstalkedList = ', this.state.cstalkedList)
		}
		// const depids = data.data.depIds

		// var ilength = depids.length
		// var j = -1

		// function addClient(result) {

		// 	j = j + 1

		// 	result.map(item => {
		// 		if (item.nodes) {
		// 			// 递归调用
		// 			const depid = depids[j]

		// 			if (item.id === depid) {
		// 				// console.log('college addClient item11 = ', item)

		// 				if (ilength - j === 1) {
		// 					// console.log('college addClient item99 = ', item)

		// 					var customerList = item.nodes
		// 					for (var m = 0; m < customerList.length; m++) {
		// 						var customer = customerList[m]

		// 						const csid = data.data.csid
		// 						if (customer.id === csid) {


		// 							var session = data.data.customerSess
		// 							console.log('addClient customer = ', customer)
		// 							console.log('addClient session = ', session)
		// 							var sessionList = customer.nodes
		// 							if (sessionList.length === 0) {
		// 								session.isChecked = false
		// 								session.csid = csid
		// 								session.type = 3

		// 								customer.nodes.push(session)

		// 							} else {
		// 								var isHave = false
		// 								for (var i = 0; i < sessionList.length; i++) {
		// 									const haveSession = sessionList[i]
		// 									if (haveSession.cid === session.cid) {
		// 										isHave = true
		// 										haveSession.query = session.query
		// 										haveSession.sid = session.sid
		// 										// customer.nodes.splice(i, 1, session)
		// 										// console.log('customer node = ', customer.nodes)
		// 									}
		// 								}

		// 								console.log("addClient customer isHave", isHave)

		// 								if (isHave === false) {
		// 									session.isChecked = false
		// 									session.csid = csid
		// 									session.type = 3

		// 									customer.nodes.push(session)
		// 								}
		// 							}

		// 						}
		// 					}
		// 				} else {

		// 					addClient(item.nodes)
		// 				}
		// 			}

		// 		}
		// 	})
		// }

		// addClient(state.collegeTreeData)
		state.colleagueNum = data.data.count
	},

	delSession(state, data) {
		console.log('college delSession data = ', data)
		console.log('college delSession data = ', data)
		// const depids = data.data.depIds
		// 
		// var ilength = depids.length
		// var j = -1
		const csid = data.data.csid
		var colleague = this.state.currentColleageInfo
		// 选中同事的会话下线
		if (colleague && colleague.id === csid) {
			var isSpeaked = data.data.sess.isSpeaked
			var isJoinList = data.data.isJoinList
			var cstalkingList = this.state.cstalkingList
			var csbrowserList = this.state.csbrowserList
			var cstalkedList = this.state.cstalkedList
			var csleavedList = this.state.csleavedList
			console.log('college delSession cstalkingList = ', cstalkingList)
			// 判断选中节点，并删除
			let delUser = {}
			let nowSelectClient = this.state.college.nowSelectClient
			if (nowSelectClient && nowSelectClient.sid === data.data.sess.sid) {
				this.state.college.nowSelectClient = null
			}
			// 判断对话中是否存在，并删除
			if (cstalkingList.length > 0) {
				for (let i = 0; i < cstalkingList.length; i++) {
					const item = cstalkingList[i]
					if (item.cid === data.data.sess.cid) {
						delUser = item
						// isHave = true
						if (this.state.cstalkingList.length === 1) {
							this.state.cstalkingList = []
						} else {
							this.state.cstalkingList.splice(i, 1,)
						}
						break;
					}
				}
			}
			//  判断浏览中是否存在，并删除
			console.log('college delSession data.data.sess.sid = ', data.data.sess.sid)
			if (csbrowserList.length > 0) {
				for (let i = 0; i < csbrowserList.length; i++) {
					const item = csbrowserList[i]
					if (item.cid === data.data.sess.cid) {
						delUser = item
						console.log('college delSession cstalkedList = ', item)
						if (this.state.csbrowserList.length === 1) {
							this.state.csbrowserList = []
						} else {
							this.state.csbrowserList.splice(i, 1)
						}
						break;
					}
				}
			} else {
				delUser.sid = data.data.sess.sid
				delUser.cid = data.data.sess.cid
			}
			//  判断对话过是否存在，并删除
			if (cstalkedList.length > 0) {
				for (let i = 0; i < cstalkedList.length; i++) {
					const item = cstalkedList[i]
					console.log('college delSession cstalkedList item.id = ', item.sid)
					if (item.cid === data.data.sess.cid) {
						delUser = item
						console.log('college delSession cstalkedList = ', item)
						if (this.state.cstalkedList.length === 1) {
							this.state.cstalkedList = []
						} else {
							this.state.cstalkedList.splice(i, 1)
						}
						break;
					}
				}
			} else {
				delUser.sid = data.data.sess.sid
				delUser.cid = data.data.sess.cid
			}

			//  判断已离开是否存在，并删除
			if (csleavedList.length > 0) {
				for (let i = 0; i < csleavedList.length; i++) {
					const item = csleavedList[i]
					if (item.cid === data.data.sess.cid) {
						delUser = item
						console.log('college delSession cstalkedList = ', item)
						if (this.state.csleavedList.length === 1) {
							this.state.csleavedList = []
						} else {
							this.state.csleavedList.splice(i, 1)
						}
						break;
					}
				}
			} else {
				delUser.sid = data.data.sess.sid
				delUser.cid = data.data.sess.cid
			}
			console.log("college delSession delUser:", delUser);
			if (isJoinList) {
				// 开口
				if (delUser) {
					delUser.isChecked = false
					delUser.isNew = false
					delUser.isFlicker = false
					delUser.canOperate = false
					if (isSpeaked) {
						console.log("college delSession isSpeaked 开口");
						this.state.cstalkedList.unshift(delUser)
					} else {
						if (this.state.csleavedList.length == this.state.maxLeaveNum) {
							console.log("college delSession isSpeaked 未开口 当前已离开人数已达最大");
							this.state.csleavedList.pop()
						}
						console.log("college delSession isSpeaked 未开口");
						this.state.csleavedList.unshift(delUser)
					}
				}
			}
			console.log('college delSession cstalkingList = ', this.state.cstalkingList)
		}
		// function delClient(result) {

		// 	j = j + 1

		// 	result.map(item => {
		// 		if (item.nodes) {
		// 			// 递归调用
		// 			const depid = depids[j]

		// 			if (item.id === depid) {
		// 				console.log('college delClient item11 = ', item)

		// 				if (ilength - j === 1) {
		// 					console.log('college delClient item99 = ', item)

		// 					var customerList = item.nodes
		// 					for (var m = 0; m < customerList.length; m++) {
		// 						var customer = customerList[m]

		// 						const csid = data.data.csid
		// 						if (customer.id === csid) {

		// 							var sessionList = customer.nodes
		// 							const cid = data.data.chatSess.cid
		// 							// const sid = data.data.chatSess.sid

		// 							for (var n = 0; n < sessionList.length; n++) {
		// 								var session = sessionList[n]
		// 								console.log('delClient customer = ', customer)
		// 								console.log('delClient session = ', session)
		// 								if (session.cid === cid) {
		// 									sessionList.splice(n, 1)

		// 									if (state.nowSelectClient !== null) {
		// 										if (state.nowSelectClient.cid === cid) {
		// 											state.nowSelectClient = null
		// 										}
		// 									}

		// 								}
		// 							}
		// 						}
		// 					}
		// 				} else {

		// 					delClient(item.nodes)
		// 				}
		// 			}

		// 		}
		// 	})
		// }

		// delClient(state.collegeTreeData)
		// state.colleagueNum = data.data.count
	},

	//ws 24 ---- OK
	updateNick(state, data) {
		console.log('college updateNick data = ', data)
		const csid = data.data.csid
		const cid = data.data.cid
		const content = data.data.content
		console.log("updateNick colleageAngle", this.state.colleageAngle);
		console.log("updateNick currentColleageInfo", this.state.currentColleageInfo);
		console.log("updateNick nowSelectClient", state.nowSelectClient);
		console.log("updateNick cstalkingList", this.state.cstalkingList);
		console.log("updateNick cid", cid);
		if (this.state.colleageAngle) {
			if (this.state.currentColleageInfo.id === csid) {
				if (state.nowSelectClient && state.nowSelectClient.cid === cid) {
					state.nowSelectClient.nickName = content
				}
			}
			const cstalkingList = this.state.cstalkingList
			const cstalkedList = this.state.cstalkedList
			if (cstalkingList.length > 0) {
				let getItem = cstalkingList.find(item => {
					return item.cid === cid
				})
				console.log("updateNick getItem:", getItem);
				if (getItem) {
					getItem.nickname = content
				}
			}
			if (cstalkedList.length > 0) {
				let getItem = cstalkedList.find(item => {
					return item.cid === cid
				})
				console.log("updateNick getItem:", getItem);
				if (getItem) {
					getItem.nickname = content
				}
			}
		}
		// const depids = data.data.depIds

		// var ilength = depids.length
		// var j = -1

		// function upNick(result) {

		// 	j = j + 1

		// 	result.map(item => {
		// 		if (item.nodes) {
		// 			// 递归调用
		// 			const depid = depids[j]

		// 			if (item.id === depid) {
		// 				console.log('college updateNick item11 = ', item)

		// 				if (ilength - j === 1) {
		// 					console.log('college updateNick item99 = ', item)

		// 					var customerList = item.nodes
		// 					for (var m = 0; m < customerList.length; m++) {
		// 						var customer = customerList[m]

		// 						const csid = data.data.csid
		// 						if (customer.id === csid) {

		// 							var sessionList = customer.nodes
		// 							const cid = data.data.cid

		// 							for (var n = 0; n < sessionList.length; n++) {
		// 								var session = sessionList[n]
		// 								console.log('updateNick customer = ', customer)

		// 								if (session.cid === cid) {
		// 									console.log('updateNick session = ', session)

		// 									const name = data.data.content
		// 									session.nickname = name
		// 									session.isUpdateNike = 1


		// 								}
		// 							}
		// 						}
		// 					}
		// 				} else {

		// 					upNick(item.nodes)
		// 				}
		// 			}

		// 		}
		// 	})
		// }

		// upNick(state.collegeTreeData)
	},

	updateLabels(state, data) {
		console.log('college updateLabels data = ', data)
		const csid = data.data.csid
		const cid = data.data.cid
		const content = data.data.content
		console.log("updateLabels colleageAngle", this.state.colleageAngle);
		console.log("updateLabels currentColleageInfo", this.state.currentColleageInfo);
		console.log("updateLabels nowSelectClient", state.nowSelectClient);
		console.log("updateLabels toUpDetail", this.state.toUpDetail);
		if (this.state.colleageAngle) {
			if (this.state.currentColleageInfo.id === csid) {
				if (state.nowSelectClient && state.nowSelectClient.cid === cid) {
					state.nowSelectClient.labels = content
				}
				this.state.toUpDetail.content = content
			}
			const cstalkingList = this.state.cstalkingList
			const cstalkinged = this.state.cstalkedList
			if (cstalkingList.length > 0) {
				let getItem = cstalkingList.find(item => {
					return item.cid === cid
				})
				console.log("updateNick getItem:", getItem);
				if (getItem) {
					getItem.labels = content
					return
				}
			}
			if (cstalkinged.length > 0) {
				let getItem = cstalkinged.find(item => {
					return item.cid === cid
				})
				console.log("updateNick getItem:", getItem);
				if (getItem) {
					getItem.labels = content
				}
			}
		}
		// const depids = data.data.depIds

		// var ilength = depids.length
		// var j = -1

		// function upNick(result) {

		// 	j = j + 1

		// 	result.map(item => {
		// 		if (item.nodes) {
		// 			// 递归调用
		// 			const depid = depids[j]

		// 			if (item.id === depid) {
		// 				console.log('college updateLabels item11 = ', item)

		// 				if (ilength - j === 1) {
		// 					console.log('college updateLabels item99 = ', item)

		// 					var customerList = item.nodes
		// 					for (var m = 0; m < customerList.length; m++) {
		// 						var customer = customerList[m]

		// 						const csid = data.data.csid
		// 						if (customer.id === csid) {

		// 							var sessionList = customer.nodes
		// 							const cid = data.data.cid

		// 							for (var n = 0; n < sessionList.length; n++) {
		// 								var session = sessionList[n]
		// 								console.log('updateLabels customer = ', customer)

		// 								if (session.cid === cid) {
		// 									console.log('updateLabels session = ', session)

		// 									const name = data.data.content
		// 									session.labels = name

		// 								}
		// 							}
		// 						}
		// 					}
		// 				} else {

		// 					upNick(item.nodes)
		// 				}
		// 			}

		// 		}
		// 	})
		// }

		// upNick(state.collegeTreeData)
	},

	upCollegeInfo(state, data) {
		console.log('college upCollegeInfo data = ', data)
		const csid = data.data.csid
		if (this.state.colleageAngle) {
			const currentColleageInfo = this.state.currentColleageInfo
			if (currentColleageInfo.id === csid) {
				if (state.nowSelectClient && state.nowSelectClient.cid === csid) {
					if (state.nowSelectClient.isUpdateNike === 0) {
						const itype = data.data.type
						const content = data.data.content
						if (itype === 5) {
							state.nowSelectClient.age = content
						} else if (itype === 2) {
							state.nowSelectClient.tel = content
						} else if (itype === 6) {
							state.nowSelectClient.gender = content
						}
					}
				}

			}

		}
		// const depids = data.data.depIds

		// var ilength = depids.length
		// var j = -1

		// function upInfo(result) {

		// 	j = j + 1

		// 	result.map(item => {
		// 		if (item.nodes) {
		// 			// 递归调用
		// 			const depid = depids[j]

		// 			if (item.id === depid) {
		// 				console.log('college upInfo item11 = ', item)

		// 				if (ilength - j === 1) {
		// 					console.log('college upInfo item99 = ', item)

		// 					var customerList = item.nodes
		// 					for (var m = 0; m < customerList.length; m++) {
		// 						var customer = customerList[m]

		// 						const csid = data.data.csid
		// 						if (customer.id === csid) {

		// 							var sessionList = customer.nodes
		// 							console.log("sessionList:", sessionList);
		// 							const cid = data.data.sess.cid
		// 							// const sid = data.data.sess.sid

		// 							for (var n = 0; n < sessionList.length; n++) {
		// 								var session = sessionList[n]
		// 								console.log('upInfo customer = ', customer)
		// 								if (session.isUpdateNike === 0) {
		// 									if (session.cid === cid) {
		// 										console.log('upInfo session = ', session)

		// 										const itype = data.data.type
		// 										const content = data.data.content
		// 										if (itype === 5) {
		// 											session.age = content
		// 										} else if (itype === 2) {
		// 											session.tel = content
		// 										} else if (itype === 6) {
		// 											session.gender = content
		// 										}

		// 									}
		// 								}
		// 							}
		// 						}
		// 					}
		// 				} else {

		// 					upInfo(item.nodes)
		// 				}
		// 			}

		// 		}
		// 	})
		// }

		// upInfo(state.collegeTreeData)
	},

	addSystemTip(state, data) {
		console.log('college addSystemTip state = ', state)
		console.log('college addSystemTip data = ', data)
	},
	updateMessageCount(state, data) {
		const csid = data.data.csid
		const count = data.data.count
		let colleagueList = state.collegeTreeData
		if (colleagueList.length > 0) {
			recursion(colleagueList)
		}
		// 递归更新对话数
		function recursion(params) {
			params.forEach(item => {
				if (item.nodes) {
					recursion(item.nodes)
				} else {
					if (item.id === csid) {
						item.talkedSessionCount = count
						return
					}
				}
			})
		}
		console.log('college updateMessageCount state = ', state)
		console.log('college updateMessageCount data = ', data)
	}
}

const actions = {
	//和没有modules的时候一样，同样的方式dispatch action
	changeName({ commit }, anotherName) {
		console.log('college actions changeName = ', anotherName)
		commit("change_name", anotherName)
	},

	updateCollegeState({
		commit
	}, data) {
		console.log('college actions updateCollegeState = ', data)
		commit('updateState', data)
	},

	updateClientStatus({
		commit
	}, data) {
		console.log('college actions updateClientStatus = ', data)
		commit('updateStatus', data)
	},

	addCollegeSession({
		commit
	}, data) {
		console.log('college actions addCollegeSession = ', data)
		commit('addSession', data)
	},

	delCollegeSession({
		commit
	}, data) {
		console.log('college actions delCollegeSession = ', data)
		commit('delSession', data)
	},

	updateClientNick({
		commit
	}, data) {
		console.log('college actions updateClientNick = ', data)
		commit('updateNick', data)
	},

	updateClientLabels({
		commit
	}, data) {
		console.log('college actions updateClientLabels = ', data)
		commit('updateLabels', data)
	},

	updateCollegeInfo({
		commit
	}, data) {
		console.log('college actions updateCollegeInfo = ', data)
		commit('upCollegeInfo', data)
	},

	updateClientMsgCount({
		commit
	}, data) {
		console.log('college actions updateClientMsgCount = ', data)
		commit('updateMsgCount', data)
	},

	addCollegeSysTip({
		commit
	}, data) {
		console.log('college actions addCollegeSysTip = ', data)
		commit('addSystemTip', data)
	},

	updateCollegeTime({ commit }, data) {
		// console.log('college actions updateCollegeTime = ', data)
		commit('updateStateTime', data)
	},
	updateCollegeMessageCount({ commit }, data) {
		// console.log('college actions updateCollegeMessageCount = ', data)
		commit('updateMessageCount', data)
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
